<template>
  <!-- ignore-enforce-focus-selector: Contatos confirma bloqueio/desbloqueio e
  limpar callback por SweetAlert. Sem liberar o container dele, o enforce-focus
  do b-modal devolve o foco pro modal e os botões do alerta ficam inoperantes
  (mesmo motivo pelo qual o ModalUsuarios carrega o atributo). -->
  <b-modal
    ref="mdlContatos"
    scrollable
    size="xl"
    ignore-enforce-focus-selector=".swal2-container"
    content-class="config-modal-content"
    body-class="px-4 pb-2 pt-0"
    header-class="config-modal-header border-0"
    footer-class="config-modal-footer"
    @hidden="aoFechar"
  >
    <template #modal-title>
      Contatos
      <span v-if="rotuloConta" class="modal-conta-inline ml-2">
        <i class="fas fa-building mr-1"></i>{{ rotuloConta }}
      </span>
    </template>

    <!-- A tela cheia do menu lateral é reaproveitada inteira, só que com a
    conta fixa (mesmo padrão do ModalAgenteSistema com PainelConectores). A
    chave amarrada ao contaId força a remontagem a cada abertura: sem isso os
    filtros e a página da conta anterior sobreviveriam na próxima. -->
    <contatos-conta v-if="contaId" :key="contaId" :conta-fixa-id="contaId" />

    <template #modal-footer="{ close }">
      <button type="button" class="btn config-btn-secondary" @click="close()">
        Fechar
      </button>
    </template>
  </b-modal>
</template>

<script>
import Contatos from "@/view/pages/painel/Contatos.vue";

export default {
  name: "ModalContatos",

  components: {
    "contatos-conta": Contatos
  },

  data() {
    return {
      contaId: null,
      rotuloConta: ""
    };
  },

  methods: {
    // Mesma assinatura do ModalAgenteSistema: a Central passa o id da linha
    // clicada e o rótulo já montado, pra deixar explícito de que conta são os
    // contatos em tela.
    abrir(contaId, rotuloConta = "") {
      this.contaId = contaId || null;
      this.rotuloConta = rotuloConta || "";

      this.$nextTick(() => this.$refs["mdlContatos"].show());
    },

    // Zera a conta ao fechar pra que a próxima abertura monte a tela do zero,
    // mesmo sendo a mesma conta: sem isso reabrir a mesma linha mostraria a
    // lista antiga enquanto a busca não voltasse.
    aoFechar() {
      this.contaId = null;
      this.rotuloConta = "";
    }
  }
};
</script>

<style scoped lang="scss"></style>
